<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box unique-report-card">
           <v-toolbar class="toolbar no-display elevation-1 mb-2" flat dense color="white">
                <v-toolbar-title>
                    <span class="font-weight-bold slate--text">
                        Subject and Group Enrollment Report
                    </span>
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn
                    color="success"
                    dark
                    small
                    rounded
                    @click="syncSubjectRegistration()"
                    :loading="sync_loader"
                >
                    <v-icon left small>mdi-sync</v-icon>
                    Sync
                </v-btn>
            </v-toolbar>

            <v-row justify="center" dense class="no-display mx-2 pt-4 ml-10">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error" small class="mr-1">*</v-icon>
                    <v-autocomplete color="indigo" dense rounded required v-model="selected_ay" :items="ay_list"
                        item-text="ay" item-value="id" label="Select Academic Year" outlined
                        @change="clearOfferingSelection" persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error" small class="mr-1">*</v-icon>
                    <v-autocomplete color="indigo" dense rounded required v-model="selected_standard"
                        :items="standard_list" item-text="standard" item-value="id" label="Please Select Standard"
                        outlined @change="clearOfferingSelection" persistent-hint hint="Please Select Standard" />
                </v-col>

                <v-col cols="12" sm="2" md="2">
                    <v-btn class="mt-7 action-fetch-btn" color="indigo" dark small rounded @click="getreport()"
                        :loading="fetch_loader">
                        Fetch
                    </v-btn>
                </v-col>
            </v-row>

            <v-spacer></v-spacer>

             <v-row v-if="flattenedReport && flattenedReport.length" justify="center" dense class="no-display mt-4 mx-2">
                <v-radio-group v-model="viewMode" row class="mb-2">
                    <v-radio label="Student Wise Report" value="student"></v-radio>
                    <v-radio label="Overall Report" value="overall"></v-radio>
                </v-radio-group>
            </v-row>

            <v-row v-if="flattenedReport && flattenedReport.length" justify="center" dense class="no-display mt-4 mx-2">
                <v-col cols="12" sm="4" md="4">
                    <v-icon color="error" small class="mr-1">*</v-icon>
                    <v-autocomplete color="indigo" dense v-model="selected_offering" :items="flattenedReport"
                        item-text="item_name" item-value="sr_no" return-object
                        label="Select Subject or Group to view Enrolled Students" outlined @change="onOfferingChange"
                        persistent-hint clearable />
                </v-col>
            </v-row>

            <v-row justify="center" class="mt-6">
                <v-col cols="12">
                     <span v-if="(viewMode === 'student' && enrolledStudents.length) || (viewMode === 'overall' && overallStudents.length) ">
                        <span class="mx-4 d-block">
                            <v-btn class="ma-2 no-display text-capitalize" tile outlined color="warning"
                                @click="viewMode === 'student' ? print() : printOverall()">
                                <v-icon left>mdi-printer</v-icon> Print Report
                            </v-btn>

                            <v-btn rounded class="no-display text-capitalize" color="success" outlined
                                @click="downloadFile" :loading="loader">
                                <v-icon left color="success">mdi-export</v-icon> Export Excel
                            </v-btn>

                            <div class="printing_area mt-4" v-if="viewMode === 'student'">
                                <v-row dense class="mb-6 mt-2 info-badge-banner pa-3 rounded-lg align-center">
                                    <v-col cols="12" sm="3" md="3" class="text-left">
                                        <span class="label-heading text-uppercase">Academic Year</span>
                                        <div class="value-text font-weight-bold">{{ display_ay }}</div>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" class="text-left border-left-divider">
                                        <span class="label-heading text-uppercase text-indigo">Selected
                                            Subject/Group</span>
                                        <div class="value-text font-weight-bold indigo--text">{{ activeTargetName }}
                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3" class="text-left border-left-divider">
                                        <span class="label-heading text-uppercase">Standard</span>
                                        <div class="value-text font-weight-bold">{{ display_standard }}</div>
                                    </v-col>
                                </v-row>

                                <div id="student-roster-table" >
                                    <div class="d-flex align-center mb-3">
                                        <v-chip color="indigo" dark small class="font-weight-bold mr-3">
                                            Total No. Of Students:{{ viewMode === 'student'
                                                        ? filteredStudents.length
                                                        : (overallStudents.length
                                                                ? overallStudents[0].total_students
                                                                : 0)
                                            }}
                                        </v-chip>

                                        <v-select v-model="feeFilter" :items="['All', 'Paid', 'Unpaid']"
                                            label="Fee Status Filter" dense outlined hide-details class="no-display"
                                            style="max-width: 150px; font-size: 13px;"></v-select>
                                    </div>

                                    <v-simple-table dense class="custom-designed-table elevation-1">
                                        <thead>
                                            <tr>
                                                <th class="text-center text-no-wrap" style="width: 5%;">Sr No.</th>
                                                <th class="text-left text-no-wrap" style="width: 12%; padding-left: 15px;">Registration Number</th>
                                                <th class="text-left text-no-wrap" style="width: 18%; padding-left: 15px;">Student Name</th>
                                                <th class="text-left text-no-wrap" style="width: 28%; padding-left: 15px;">Subject / Group</th>
                                                <th class="text-center text-no-wrap" style="width: 11%;">Total Fees</th>
                                                <th class="text-center text-no-wrap" style="width: 11%;">Fee Status</th>
                                                <th class="text-center text-no-wrap" style="width: 11%;">Fee Receipt</th>
                                                <th class="text-right text-no-wrap" style="width: 11%; padding-right: 15px;">Fees Paid Amount</th>
                                                <th class="text-center text-no-wrap" style="width: 14%;">Fees Paid Date</th>
                                                <th class="text-center text-no-wrap no-display" style="width: 10%;">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(stu, sIdx) in filteredStudents" :key="sIdx" class="table-row-hover">
                                                <td class="text-center sr-num-col">{{ sIdx + 1 }}</td>
                                                <td class="text-left prn-text-col" style="padding-left: 15px !important;">{{ stu.learner_prn }}</td>
                                                <td class="text-left name-text-col" style="padding-left: 15px !important;">{{ stu.learner_name }}</td>
                                                
                                                <td class="text-left" style="padding-left: 15px !important; white-space: normal !important; overflow: visible !important; text-overflow: clip !important; word-break: break-word !important; line-height: 1.4 !important; padding-top: 8px !important; padding-bottom: 8px !important;">
                                                    {{ stu.subject_names }}
                                                </td>

                                                <td class="text-center fees-text-col">
                                                    <span v-if="stu.total_fees" class="font-weight-bold"> ₹ {{ stu.total_fees.toLocaleString('en-IN', {
                                                        minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                    </span>
                                                    <span v-else class="grey--text lighten-2">--</span>
                                                </td>
                                                
                                                <td class="text-center">
                                                    <v-chip class="font-weight-bold custom-status-chip" size="x-small"
                                                        small dense :color="stu.is_fees_paid === 'Yes' ? 'success' : 'error'" outlined>
                                                        <v-icon left x-small>{{ stu.is_fees_paid === 'Yes' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
                                                        {{ stu.is_fees_paid === 'Yes' ? 'Paid' : 'Unpaid' }}
                                                    </v-chip>
                                                </td>
                                                <td class="text-center">
                                                        <v-btn v-if="stu.is_fees_paid === 'Yes'" x-small rounded id="wv_btn" outlined color="warning"
                                                            @click="printreceipt(stu.receipts[0].receipt_no, stu.receipts[0].ay,stu.receipts[0].registration_number)"> <v-icon x-small left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                                                    <span v-else>--</span>
                                                </td>
                                                
                                                <td class="text-right currency-text-col" style="padding-right: 15px !important;">
                                                    ₹ {{ stu.fees_amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                </td>
                                                
                                                <td class="text-center date-text-col" style="white-space: normal !important; word-break: break-all !important; font-size: 9pt !important; padding: 6px 4px !important;">
                                                    {{ stu.fees_paid_date ? stu.fees_paid_date : '--' }}
                                                </td>

                                                <td class="text-center no-display">
                                                    <v-btn icon small color="indigo" @click="editStudent(stu)">
                                                        <v-icon small>mdi-pencil</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </div>
                            </div>
                             <div v-else>
                               <v-simple-table dense class="custom-designed-table elevation-1">
                                <thead>
                                    <tr>
                                        <th class="text-left" style="padding-left: 20px;">Group / Subject Name</th>
                                        <th class="text-center" style="width: 15%;">Total</th>
                                        <th class="text-center" style="width: 15%;">Paid</th>
                                        <th class="text-center" style="width: 15%;">Unpaid</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, i) in overallStudents" :key="i">
                                        <td class="text-left" style="padding-left: 20px;">{{ item.name }}</td>
                                        <td class="text-center font-weight-bold">{{ item.count }}</td>
                                        <td class="text-center success--text font-weight-bold">{{ item.paid_count }}</td>
                                        <td class="text-center error--text font-weight-bold">{{ item.unpaid_count }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            </div>
                        </span>
                    </span>
                </v-col>
            </v-row>
        </v-card>

        <!-- Edit Dialog -->
        <v-dialog v-model="editDialog" max-width="700px" persistent>
            <v-card>
                <v-card-title class="headline indigo--text">
                    <span class="font-weight-bold">Edit Subject/Group</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="editedItem.learner_name" label="Student Name" disabled outlined
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="editedItem.learner_prn" label="Registration Number" disabled
                                    outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-textarea v-model="editedItem.subject_names" label="Current Assigned Subject / Group"
                                    disabled outlined dense rows="2" auto-grow
                                    background-color="grey lighten-4"></v-textarea>
                            </v-col>

                            <v-divider class="my-3 col-12"></v-divider>

                            <v-col cols="12">
                                <div class="subtitle-2 font-weight-bold indigo--text mb-2">
                                    Select New Subject / Group
                                </div>

                                <div v-if="finalList && finalList.length">
                                    <v-row dense>
                                        <v-col cols="12" v-if="individualSubjectsList.length">
                                            <v-autocomplete v-model="selectedIndividualSubjects"
                                                :items="individualSubjectsList" item-text="displayName"
                                                item-value="course_offering_id" return-object
                                                label="Select Individual Subject"
                                                outlined dense clearable>
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" v-for="(head, index) in groupSubjectsList" :key="index">
                                            <v-autocomplete 
                                                v-model="head.selected_offering" :items="head.subjects"
                                                item-text="displayName" item-value="course_offering_id" return-object
                                                :label="`Select ${head.selection_type}`" outlined dense clearable>
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div v-else class="caption error--text">
                                    No subject/group options available for this student.
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="editDialog = false">Cancel</v-btn>
                    <v-btn color="indigo" class="white--text" @click="saveEdit" :loading="editLoader">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


       <v-dialog v-model="dialog" max-width="900px">
            <v-card>

                <v-card-title class="font-weight-bold">
                    Sync Result Summary
                </v-card-title>

                <v-card-text>

                    <v-sheet class="pa-3 mb-4" color="green lighten-5" rounded>
                        <div class="font-weight-bold green--text mb-2">
                            Success Records ({{ syncSummary.success.length }})
                        </div>

                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Reg No</th>
                                    <th>Learner ID</th>
                                    <th>Learner</th>
                                    <th>Registered</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in syncSummary.success" :key="'s'+i">
                                    <td>{{ item.regNo }}</td>
                                    <td>{{ item.learnerId }}</td>
                                    <td>{{ item.learner }}</td>
                                    <td>{{ item.registered }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-sheet>

                    <v-sheet class="pa-3" color="red lighten-5" rounded>
                        <div class="font-weight-bold red--text mb-2">
                            Failed Records ({{ syncSummary.failed.length }})
                        </div>

                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Reg No</th>
                                    <th>Learner Id</th>
                                    <th>Learner</th>
                                    <th>Reason(s)</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, i) in syncSummary.failed" :key="'f'+i">
                                    <td>{{ item.regNo }}</td>
                                    <td>{{ item.failed && item.failed.length ? item.failed[0].learnerId : '-' }}</td>
                                    <td>{{ item.failed && item.failed.length ? item.failed[0].learner : '-' }}</td>
                                    <td>{{ item.failed && item.failed.length ? item.failed[0].reason : '-' }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-sheet>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <v-overlay :value="dialogLoader" opacity="0.6" color="slate">
            <v-progress-circular indeterminate size="64" color="indigo" width="5"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import "@/assets/css/color.css";

export default {
    data() {
        return {
            loader: false,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            fetch_loader: false,

            ay_list: [],
            selected_ay: "",
            selected_standard: "",
            display_ay: "",
            display_standard: "",

            standard_list: [],
            report_data: [],
            org_basic_data: {},

            selected_offering: null,
            dialogLoader: false,
            activeTargetName: "",
            enrolledStudents: [],
            sync_loader: false,
            tenant: null,
            feeFilter: "All",
            syncDialog: false,
            dialog: false,
            dialogData: [],
            syncSummary: {
                success: [],
                failed: []
            },
            failedHeaders: [
                { text: "Registration No", value: "reg_no" },
                { text: "Learner Name", value: "learner" },
                { text: "Reason", value: "reason" }
            ],

            successHeaders: [
                { text: "Registration No", value: "reg_no" },
                { text: "Learner Name", value: "learner" }
            ],
            viewMode: "student",
            overallStudents: [],
            editDialog: false,
            editLoader: false,
            editedItem: {
                learner_name: "",
                learner_prn: "",
                total_fees: 0,
                fees_amount: 0,
                is_fees_paid: "No",
                fees_paid_date: ""
            },
            application_form_data: {
                admission_form_no: null,
                admission_form_id: null
            },
            finalList:[],
            selectedIndividualSubjects: [],
            old_subject_group:null
        };
    },
    watch: {
        viewMode() {
            if (this.selected_offering) {
               this.onOfferingChange(this.selected_offering);
            }
        }
    },

    methods: {
        printreceipt(receipt_no, ay,registration_number){
               // this.receipt_no = receipt_no;
                // this.dialog_print = true;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                if (this.tenant == "zeal") {
                    alert("Under development....");
                } else if (this.tenant == "wws") {
                    alert("Under development....");
                } else if (this.tenant == "uwws") {
                    alert("Under development....");
                } else if (this.tenant == "vvp") {
                    alert("Under development....");
                } else if (this.tenant == "sanjivani") {
                    alert("Under development....");
                } else if (this.tenant == "desschool") {
                    let routeData = this.$router.resolve({
                        name: "student-elective-fees-receipts-des",
                    });
                    window.open(routeData.href, "_blank");
                } else {
                    alert("Under development....");
                }
        },
       print() {
            const banner = `
                <div style="display:flex; gap:20px; background:#f8fafc; border:1px solid #cbd5e1; padding:12px; margin-bottom:16px; border-radius:6px;">
                    <div style="flex:1;">
                        <div style="font-size:7.5pt; color:#64748b; text-transform:uppercase; letter-spacing:0.8px;">Academic Year</div>
                        <div style="font-size:11pt; font-weight:700; color:#1e293b;">${this.display_ay}</div>
                    </div>
                    <div style="flex:2; border-left:2px solid #cbd5e1; padding-left:15px;">
                        <div style="font-size:7.5pt; color:#64748b; text-transform:uppercase; letter-spacing:0.8px;">Selected Subject/Group</div>
                        <div style="font-size:11pt; font-weight:700; color:#3730a3;">${this.activeTargetName}</div>
                    </div>
                    <div style="flex:1; border-left:2px solid #cbd5e1; padding-left:15px;">
                        <div style="font-size:7.5pt; color:#64748b; text-transform:uppercase; letter-spacing:0.8px;">Standard</div>
                        <div style="font-size:11pt; font-weight:700; color:#1e293b;">${this.display_standard}</div>
                    </div>
                </div>
            `;

            const rows = this.filteredStudents.map((stu, idx) => `
                <tr style="background:${idx % 2 === 0 ? '#ffffff' : '#f8fafc'};">
                    <td style="text-align:center; color:#94a3b8;">${idx + 1}</td>
                    <td style="font-family:monospace; color:#475569;">${stu.learner_prn}</td>
                    <td style="font-weight:500; color:#0f172a;">${stu.learner_name}</td>
                    <td style="font-weight:500; color:#0f172a;">${stu.subject_names}</td>
                    <td style="text-align:center; color:#334155;">
                        ${stu.total_fees ? '₹ ' + stu.total_fees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '--'}
                    </td>
                    <td style="text-align:center;">
                        <span style="
                            display:inline-block; padding:2px 6px; border-radius:12px; font-size:7.5pt; font-weight:600;
                            border: 1px solid ${stu.is_fees_paid === 'Yes' ? '#16a34a' : '#dc2626'};
                            color: ${stu.is_fees_paid === 'Yes' ? '#16a34a' : '#dc2626'};
                        ">${stu.is_fees_paid === 'Yes' ? '✓ Paid' : '✗ Unpaid'}</span>
                    </td>
                    <td style="text-align:right; font-family:monospace; font-weight:700;">
                        ₹ ${stu.fees_amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style="text-align:center; color:#475569;">${stu.fees_paid_date || '--'}</td>
                </tr>
            `).join('');

            const html = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <title>Enrollment Report - ${this.activeTargetName}</title>
                    <style>
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body { font-family: Arial, sans-serif; font-size: 10pt; padding: 12mm; background: #fff; color: #1e293b; }
                        h2 { font-size: 13pt; font-weight: 700; color: #334155; margin-bottom: 12px; }
                        .chip { 
                            display: inline-block; background: #3730a3; color: #fff; 
                            font-size: 9pt; font-weight: 600; padding: 3px 12px; 
                            border-radius: 12px; margin-bottom: 12px; 
                        }
                        table { width: 100%; table-layout: fixed; border-collapse: collapse; border: 1px solid #cbd5e1; border-radius: 4px; overflow: hidden; }
                        thead tr th { 
                            background-color: #1e293b; color: #fff; font-size: 9pt; 
                            font-weight: 600; padding: 10px 6px; text-align: left;
                            -webkit-print-color-adjust: exact; print-color-adjust: exact;
                        }
                        tbody tr td { 
                            font-size: 9pt; padding: 8px 6px; 
                            border-bottom: 1px solid #e2e8f0; color: #334155;
                            word-wrap: break-word;
                        }
                        tbody tr:last-child td { border-bottom: none; }
                        @media print {
                            body { padding: 8mm; }
                            table { page-break-inside: auto; }
                            tr { page-break-inside: avoid; page-break-after: auto; }
                            thead { display: table-header-group; }
                        }
                    </style>
                </head>
                <body>
                    <h2>Subject and Group Enrollment Report</h2>
                    ${banner}
                    <div class="chip">Total Students: ${this.filteredStudents.length}</div>
                    <table>
                        <thead>
                            <tr>
                                <th style="width: 5%; text-align:center;">Sr No.</th>
                                <th style="width: 14%;">Registration No.</th>
                                <th style="width: 12%;">Student Name</th>
                                <th style="width: 31%;">Subject/Group Name</th>
                                <th style="width: 10%; text-align:center;">Total Fees</th>
                                <th style="width: 10%; text-align:center;">Fee Status</th>
                                <th style="width: 10%; text-align:right;">Fees Paid</th>
                                <th style="width: 10%; text-align:center;">Paid Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rows}
                        </tbody>
                    </table>
                </body>
                </html>
            `;

            const printWindow = window.open('', '_blank', 'width=1000,height=700');
            printWindow.document.write(html);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        },

        printOverall() {
            const rows = this.overallStudents.map((item, idx) => `
                <tr>
                    <td style="text-align:center; padding:8px; border-bottom:1px solid #ddd;">${idx + 1}</td>
                    <td style="padding:8px; border-bottom:1px solid #ddd;">${item.name}</td>
                    <td style="text-align:center; padding:8px; border-bottom:1px solid #ddd;">${item.count}</td>
                    <td style="text-align:center; padding:8px; border-bottom:1px solid #ddd; color: green;">${item.paid_count}</td>
                    <td style="text-align:center; padding:8px; border-bottom:1px solid #ddd; color: red;">${item.unpaid_count}</td>
                </tr>
            `).join('');

            const html = `
                <html>
                <body>
                    <h2>Overall Enrollment Summary</h2>
                    <table style="width:100%; border-collapse:collapse;">
                        <thead>
                            <tr style="background:#1e293b; color:#fff;">
                                <th>S.No</th><th>Group/Subject</th><th>Total</th><th>Paid</th><th>Unpaid</th>
                            </tr>
                        </thead>
                        <tbody>${rows}</tbody>
                    </table>
                </body>
                </html>
            `;
            const win = window.open('', '_blank');
            win.document.write(html);
            win.print();
        },

        clearOfferingSelection() {
            this.selected_offering = null;
            this.enrolledStudents = [];
            this.activeTargetName = "";
            this.feeFilter = "All";
        },

        getreport() {
            if (!this.selected_ay || !this.selected_standard) {
                this.showSnackbar("#b71c1c", "Select Academic Year and Standard...");
                return;
            }

            this.clearOfferingSelection();
            this.fetch_loader = true;

            const payload = {
                academicyear_id: this.selected_ay,
                standard_id: this.selected_standard
            };

            axios
                .post("/admission/getSubjectsAndGroupsReport", payload)
                .then((res) => {
                    this.fetch_loader = false;
                    if (res.data.flag === "YES") {
                        this.report_data = res.data.reportData;
                        this.org_basic_data = res.data.org_basic_data || {};
                        this.display_ay = res.data.display_ay;
                        this.display_standard = res.data.display_standard;
                    } else {
                        this.report_data = [];
                        this.showSnackbar("#b71c1c", res.data.msg || "No Subjects/Groups found.");
                    }
                })
                .catch((error) => {
                    this.fetch_loader = false;
                    console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong fetching report structure...");
                });
        },

        onOfferingChange(offeringObj) {
            if (!offeringObj) {
                this.enrolledStudents = [];
                this.activeTargetName = "";
                this.feeFilter = "All";
                return;
            }
            this.activeTargetName = offeringObj.item_name;

            if (this.viewMode === "student") {
                this.fetchStudents(offeringObj);
            } else {
                this.fetchOverallCount(offeringObj);
            }
        },

        fetchStudents(row) {
            this.activeTargetName = row.item_name;
            this.enrolledStudents = [];
            this.feeFilter = "All";
            this.dialogLoader = true;

            let payload = {};
            if (row.selection_type === "ALL") {

                payload = {
                    type: "ALL",
                    items: this.flattenedReport
                        .filter(x => x.selection_type !== "ALL")
                        .map(x => ({
                            id: x.raw_id,
                            type: x.selection_type
                        }))
                };

            } else {

                payload = {
                    id: row.raw_id,
                    type: row.selection_type
                };

            }
            
            axios
                .post("/admission/getEnrolledStudents", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.enrolledStudents = res.data.studentList || [];

                        console.log("Students loaded:", this.enrolledStudents);
                    } else {
                        this.showSnackbar("#b71c1c", "Failed to retrieve student records.");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.showSnackbar("#b71c1c", "An unexpected network error occurred.");
                })
                .then(() => {
                    this.dialogLoader = false;
                });
        },

        fetchOverallCount(row) {
            this.overallStudents = [];
            this.dialogLoader = true;

            let payload = {};
            if (row.selection_type === "ALL") {

                payload = {
                    type: "ALL",
                    items: this.flattenedReport
                        .filter(x => x.selection_type !== "ALL")
                        .map(x => ({
                            id: x.raw_id,
                            type: x.selection_type
                        }))
                };

            } else {

                payload = {
                    id: row.raw_id,
                    type: row.selection_type
                };

            }

            axios
                .post("/admission/getOverallEnrollmentCount", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        // this.overallStudents = [{
                        //     name: row.item_name,
                        //     total_students: res.data.total_students
                        // }];
                        // Inside fetchOverallCount's .then()
                        this.overallStudents = res.data.data.map(x => ({
                            name: x.name, 
                            total_students: x.count,
                            id: x.id,
                            type: x.type,
                            count: x.count,
                            paid_count: x.paid_count,
                            unpaid_count: x.unpaid_count,
                        }));
                    } else {
                        this.showSnackbar( "#b71c1c","Failed to retrieve overall count.");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.showSnackbar("#b71c1c","Something went wrong.");
                })
                .finally(() => {
                    this.dialogLoader = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        onload() {
            axios
                .post("/QuizScheduling/getAllData")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.ay_list = res.data.ay_list;
                        // this.standard_list = res.data.standard_list;
                        this.standard_list = res.data.standard_list.filter(item => item.standard !== "All");
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong loading basic records...");
                });
        },

        downloadFile() {
            this.loader = true;
            let exportData = [];
            let filename = "";

            if (this.viewMode === 'student') {
                // Export Student Wise Report
                exportData = this.filteredStudents.map((item, index) => ({
                    "S.No": index + 1,
                    "Registration Number": item.learner_prn,
                    "Student Name": item.learner_name,
                    "Subject/Group": item.subject_names,
                    "Academic Year": this.display_ay,
                    "Standard": this.display_standard,
                    "Total Fees": item.total_fees,
                    "Is Fees Paid?": item.is_fees_paid,
                    "Fees Amount Paid": item.fees_amount,
                    "Fees Paid Date": item.fees_paid_date,
                }));
                filename = `Enrollment_Roster_${this.display_standard.replace(/\s+/g, '_')}.xlsx`;
            } else {
                // Export Overall Report
                exportData = this.overallStudents.map((item, index) => ({
                    "S.No": index + 1,
                    "Group / Subject Name": item.name,
                    "Total Students": item.count,
                    "Paid Count": item.paid_count,
                    "Unpaid Count": item.unpaid_count
                }));
                filename = `Overall_Enrollment_Summary.xlsx`;
            }

            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
            XLSX.writeFile(workbook, filename);
            this.loader = false;
        },
        
        syncSubjectRegistration() {
            if (!this.selected_ay || !this.selected_standard) {
                this.showSnackbar("error", "Select Academic year and Standard");
                return;
            }
            this.sync_loader = true;
            
            axios.post("/admission/syncSubjectRegistration", {
                ay: this.selected_ay,
                standard: this.selected_standard
            })
            .then((res) => {

                this.syncSummary = {
                    success: res.data.success_list || [],
                    failed: res.data.failed_list || []
                };

                this.dialog = true; 

                if (res.data.failed_count > 0 && res.data.success_count === 0) {
                    this.showSnackbar( "error",`Sync failed for ${res.data.failed_count} learner(s)`);
                }
                else if (res.data.failed_count > 0) {
                    this.showSnackbar("warning",`Sync completed with ${res.data.failed_count} failure(s)`);
                }
                else {this.showSnackbar("success","Sync completed successfully");
                }
            })
            .catch((err) => {
                console.error("Sync Error: ", err);
                this.showSnackbar("error", "Something went wrong while syncing.");
            })
            .finally(() => {
                this.sync_loader = false;
            });
        },
        editStudent(stu) {
            this.editedItem = Object.assign({}, stu); 
            this.editDialog = true;
            this.old_subject_group = stu.group_tdsg_id != null
                                    ? stu.group_tdsg_id
                                    : stu.subject_course_off

            this.application_form_data = {
                admission_form_no: stu.admission_form_no || null,
                admission_form_id: stu.admission_form_id || null
            };
            console.log("Payload being sent:", this.application_form_data);
        
            this.getSubjects();
        },
        
        getSubjects() {
            this.subjectLoader = true; 
            
            axios.post("/admissionForm/subjectGroupDetails", this.application_form_data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.subjectSelectionDone = res.data.subjectSelectionDone;
                        
                        this.finalList = res.data.finalList.map(item => {
                            let selection = item.selected_course_offering_id;
                            if (selection == null) {
                                selection = item.pickup_count > 1 ? [] : null;
                            }

                            let formattedSubjects = (item.subjects || []).map(sub => {
                                let subjectsString = "";
                                
                                if (sub.group_subjects && sub.group_subjects.length > 0) {
                                    subjectsString = sub.group_subjects.map(gs => gs.subject_name).join(", ");
                                }
                                
                                return {
                                    ...sub,
                                    id: sub.tdsg_id, 
                                    displayName: subjectsString ? `${sub.subject_name} (${subjectsString})` : sub.subject_name
                                };
                            });

                             let oldId = null;
                                if (selection) {
                                    oldId = item.is_group ? (selection.tdsg_id || selection.id) : (selection.course_offering_id || selection.id);
                                }
                            
                            return { ...item, subjects: formattedSubjects, selected_offering: selection, original_saved_id: oldId };
                        });
                        
                        this.$store.commit("setform_progress", res.data.form_progress);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching subjects: ", err);
                    this.showSnackbar("error", "Failed to fetch subject details.");
                })
                .finally(() => { 
                    this.subjectLoader = false; 
                });
        },
        saveEdit() {
            this.editLoader = true;
            let selectedGroups = [];
            let selectedSingles = [];

            if (this.selectedIndividualSubjects) {
                const subjectId = this.selectedIndividualSubjects.course_offering_id || this.selectedIndividualSubjects.id;
                if (subjectId) {
                    selectedSingles.push(subjectId);
                }
            }

            this.finalList.forEach(head => {
                if (head.is_group) {
                    let selected = head.selected_offering;
                    if (!selected) return; 

                    let selectedArray = Array.isArray(selected) ? selected : [selected];

                    selectedArray.forEach(obj => {
                        const groupId = obj.tdsg_id || obj.subject_group_id || obj.id;
                        if (groupId) {
                            selectedGroups.push({ group_id: groupId });
                        }
                    });
                }
            });

            let payload = {
                admission_form_id: this.application_form_data.admission_form_id,
                selectedGroups: selectedGroups,
                selectedSingles: [...new Set(selectedSingles)],
                old_subject_group: this.old_subject_group 
            };

            axios.post("/admissionForm/editSelectedSubjectsAndGroups", payload)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.showSnackbar("success", "Updated Successfully");
                        this.editDialog = false; 
                        this.old_subject_group = null;
                        if (this.selected_offering) {
                            this.onOfferingChange(this.selected_offering);
                        }
                    } else {
                        this.showSnackbar("error", res.data.msg || "Error updating subjects/group");
                    }
                })
                .catch((err) => {
                    console.error("Error updating subjects: ", err);
                    this.showSnackbar("error", "Server Error: Could not save data.");
                })
                .finally(() => { 
                    this.editLoader = false; 
                });
        }
    },

    mounted() {
        this.onload();
        this.tenant = localStorage.getItem("EPS-tenant");
    },

    computed: {
        filteredStudents() {
            if (!this.enrolledStudents || this.enrolledStudents.length === 0) {
                return [];
            }
            if (this.feeFilter === "Paid") {
                return this.enrolledStudents.filter(student => student.is_fees_paid === "Yes");
            }
            if (this.feeFilter === "Unpaid") {
                return this.enrolledStudents.filter(student => student.is_fees_paid === "No");
            }
            return this.enrolledStudents;
        },

        flattenedReport() {
            if (!this.report_data || this.report_data.length === 0) {
                return [];
            }

            let temp = [];
            let counter = 1;

            this.report_data.forEach((row) => {
                if (row.selection_type === "Subject" && row.linked_subject_list && row.linked_subject_list.length > 0) {
                    row.linked_subject_list.forEach((sub) => {
                        temp.push({
                            sr_no: counter++,
                            raw_id: sub.id,
                            stream_template: `${row.stream_name} / ${row.template_name}`,
                            subject_head: row.subject_head,
                            selection_type: row.selection_type,
                            item_name: `${sub.name}`,
                            fees: sub.fees,
                            capacity: sub.capacity,
                            balance: sub.balance_student
                        });
                    });
                }
                else if (row.selection_type === "Group" && row.linked_group_list && row.linked_group_list.length > 0) {
                    row.linked_group_list.forEach((grp) => {
                        temp.push({
                            sr_no: counter++,
                            raw_id: grp.id,
                            stream_template: `${row.stream_name} / ${row.template_name}`,
                            subject_head: row.subject_head,
                            selection_type: row.selection_type,
                            item_name: `${grp.name}`,
                            fees: grp.fees,
                            capacity: grp.capacity,
                            balance: grp.balance_student
                        });
                    });
                }
            });

             temp.unshift({
                    sr_no: 0,
                    raw_id: 0,
                    selection_type: "ALL",
                    item_name: "All"
                });

            return temp;
        },
        individualSubjectsList() {
            if (!this.finalList) return [];
            
            let combinedSubjects = [];
            this.finalList.forEach(head => {
                if (!head.is_group && head.subjects && head.subjects.length > 0) {
                    combinedSubjects.push(...head.subjects);
                }
            });
            return combinedSubjects;
        },

        totalIndividualPickupCount() {
            if (!this.finalList) return 0;
            return this.finalList
                .filter(head => !head.is_group)
                .reduce((total, head) => total + (head.pickup_count || 0), 0);
        },

        groupSubjectsList() {
            if (!this.finalList) return [];
            return this.finalList.filter(head => head.is_group);
        }
    }
};
</script>

<style scoped>
.unique-report-card {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    background-color: #fafbfc !important;
}

.info-badge-banner {
    background-color: #f1f5f9 !important;
    border: 1px solid #e2e8f0;
}

.label-heading {
    font-size: 7.5pt;
    letter-spacing: 0.8px;
    color: #64748b;
    display: block;
    margin-bottom: 2px;
}

.value-text {
    font-size: 11pt;
    color: #1e293b;
}

.border-left-divider {
    border-left: 2px solid #cbd5e1;
    padding-left: 20px !important;
}

.table-title-context {
    font-size: 13pt;
    font-weight: 700;
    color: #334155;
    letter-spacing: -0.2px;
}

.custom-designed-table {
    width: 100% !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 6px !important;
    overflow: hidden;
    background-color: #ffffff !important;
}

.custom-designed-table>>>table {
    width: 100% !important;
    table-layout: fixed !important;
}

.custom-designed-table>>>thead tr th {
    background-color: #1e293b !important;
    color: #ffffff !important;
    font-size: 9.5pt !important;
    font-weight: 600 !important;
    height: 44px !important;
    letter-spacing: 0.3px;
    border: none !important;
}

.custom-designed-table>>>tbody tr {
    height: 38px !important;
    transition: background-color 0.15s ease;
}

.custom-designed-table>>>tbody tr:nth-of-type(even) {
    background-color: #f8fafc !important;
}

.custom-designed-table>>>tbody tr td {
    font-size: 9.5pt !important;
    border-bottom: 1px solid #e2e8f0 !important;
    color: #334155 !important;
    padding: 6px 12px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.custom-designed-table>>>tbody tr:last-child td {
    border-bottom: none !important;
}

.table-row-hover:hover {
    background-color: #f0f4f8 !important;
}

.sr-num-col {
    color: #94a3b8 !important;
    font-weight: 500;
}

.prn-text-col {
    font-family: 'SFMono-Regular', Consolas, Monaco, monospace;
    font-size: 9pt !important;
    color: #475569 !important;
}

.name-text-col {
    font-weight: 600 !important;
    color: #0f172a !important;
}

.fees-text-col {
    color: #334155 !important;
}

.currency-text-col {
    font-family: 'SFMono-Regular', Consolas, monospace;
    font-weight: 700 !important;
    color: #1e293b !important;
}

.custom-status-chip {
    font-size: 8pt !important;
    height: 22px !important;
}

.selection-placeholder {
    border: 2px dashed #cbd5e1;
    border-radius: 8px;
    background-color: #ffffff;
}


@media print {
    /* html, body {
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        background-color: #ffffff !important;
    } */

    html,
    body {
        overflow: hidden !important;
        height: auto !important;
    }


    div,
    .v-card,
    .v-card__text,
    .v-window,
    .v-window-item,
    .row,
    .col,
    span {
        margin: 0 !important;
        padding: 0 !important;
        box-shadow: none !important;
        border: none !important;
    }

    .no-display {
        display: none !important;
    }

    body * {
        visibility: hidden !important;
    }

    .printing_area,
    .printing_area * {
        visibility: visible !important;
    }

    /* .printing_area {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 8mm 8mm !important;
        display: block !important;
    } */

    .printing_area {
        /* Remove position, top, left completely */
        width: 100% !important;
        margin: 0 !important;
        padding: 8mm !important;
        display: block !important;
    }

    .v-overlay {
        display: none !important;
    }


    .custom-designed-table {
        border: 1px solid #475569 !important;
        border-radius: 0 !important;
        margin-top: 15px !important;
        page-break-inside: auto !important;
    }

    .custom-designed-table>>>table {
        page-break-inside: auto !important;
    }

    .custom-designed-table>>>tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
    }

    .custom-designed-table>>>thead tr th {
        background-color: #f1f5f9 !important;
        color: #000000 !important;
        font-weight: bold !important;
        border-bottom: 2px solid #000000 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .custom-designed-table>>>tbody tr td {
        color: #000000 !important;
        border-bottom: 1px solid #cbd5e1 !important;
    }

    .info-badge-banner {
        background-color: #f8fafc !important;
        border: 1px solid #cbd5e1 !important;
        padding: 12px !important;
        display: flex !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .border-left-divider {
        border-left: 1px solid #cbd5e1 !important;
        padding-left: 15px !important;
    }
}
</style>